import { queryOptions, useQuery } from '@tanstack/react-query';

import { ApiResponse, QueryOptions } from '@cast/shared-types';
import { makeIsEnabled } from '@cast/utils';

import { apiClient } from '@cast/infrastructure-api';

const apiFn = apiClient.dbo.getQueryErrors;

export type QueryErrorsResponse = ApiResponse<typeof apiFn>;

const QUERY_ERRORS_QUERY_KEY = 'dbo-query-errors';

const getQueryErrorsQueryKey = (params: Parameters<typeof apiFn>[0]) =>
  [QUERY_ERRORS_QUERY_KEY, params] as const;

export const useQueryErrorsQuery = <SELECT = QueryErrorsResponse>(
  params: Parameters<typeof apiFn>[0],
  options?: QueryOptions<QueryErrorsResponse, SELECT>
) =>
  useQuery(
    queryOptions({
      queryKey: getQueryErrorsQueryKey(params),
      queryFn: async () => {
        const { data } = await apiFn(params);
        return data;
      },
      enabled: makeIsEnabled(
        !!params.organizationId && !!params.instanceId,
        options?.enabled ?? true
      ),
      ...options,
    })
  );
